<div class="dust-particles">
  <div
    class="particle"
    *ngFor="let p of particles"
    [ngStyle]="{
      '--size': p.size,
      '--color': p.color,
      '--opacity': p.opacity,
      '--delay': p.delay,
      '--start-x': p.startX,
      '--start-y': p.startY,
      '--start-z': p.startZ,
      '--end-x': p.endX,
      '--end-y': p.endY,
      '--end-z': p.endZ,
    }"
  ></div>
</div>
